export default {
  beforeMount() {
    window.addEventListener("message", this.receiveMessage);
  },
  methods: {
    receiveMessage({
      data,
      origin
    }) {
      switch (data === null || data === void 0 ? void 0 : data.type) {
        case "SetToken":
          if (origin.includes("linkr.com") || origin.includes("localhost")) {
            const token = data.data.token || "";
            const userId = data.data.userId || "";
            localStorage.setItem("token", token);
            localStorage.setItem("userid", userId);
            window.parent.postMessage({
              type: "SetTokenStatus",
              data: {
                status: localStorage.getItem("token") === token
              }
            }, "*");
          }
          break;
        default:
          break;
      }
    }
  }
};